import type { SynthesisSessionRepository } from "../repositories/synthesis-session-repository"

export const makeDeleteSynthesisSession = (repo: SynthesisSessionRepository) =>
  (id: string) => repo.delete(id)
